import Component from "../Component";
import { ContractTypeSettings } from "../models/ContractTypeSettings";

export default async function LoadContractTypeStyle(component: Component) {
  const url = "api/Contract/GetContractTypeStyle";

  const response = await component.apiService.get(url);
  const data = await response.json();
  const settings = data.content as ContractTypeSettings;

  let css = ``;
  settings.TypeSettings.forEach(s => {
    css +=
      `
        li[role="option"][data-contracttype="${s.Type}"] {
          margin: 0.2rem;
          border-radius: 0.4rem;
          background-color: ${s.BackgroundColor};
        }

        li[role="option"][data-contracttype="${s.Type}"]:hover {
          background-color: ${s.HoverBackgroundColor};
        }
      `;
  });

  const style = document.createElement("style");
  style.innerHTML = css;
  document.head.appendChild(style);
}
